import * as React from 'react';
import * as Forms from '../../../components/form-elements/_index';
import { SelectListItem } from '../../../models/utilities/selectlist-item';

interface IProps {
    name                    : string;
    nameChange              : any;
    serviceCenter           : string;
    serviceCenterChange     : any;
    cutoffDate              : Date|undefined;
    cutoffDateChange        : any;
    serviceCenters          : Array<SelectListItem<string>>;
    serviceCenterDisable    : boolean;
    disable                 : boolean;
    showCompactUI           : boolean;
}

export const EditDeliveryBasicInfo = (props: IProps) => (
    <React.Fragment>

        <div className="row">
            <div className={ props.showCompactUI ? "col-md-12" : "col-md-6"}>
                <Forms.TextInput
                    type="text"
                    id="truckName"
                    testID="truck-basic-info-name"
                    label="Name"
                    disable={ props.disable }
                    onChange={props.nameChange}
                    value={props.name} />
            </div>
            <div className={ props.showCompactUI ? "col-md-12" : "col-md-6"}>
                <Forms.SelectInput
                    id="serviceCenter"
                    testID="truck-basic-info-servicecenter"
                    label="Service Center"
                    onChange={props.serviceCenterChange}
                    options={props.serviceCenters}
                    value={props.serviceCenter}
                    disable={ props.serviceCenterDisable } />
            </div>
            <div className={ props.showCompactUI ? "col-md-12" : "col-md-6"}>
                <Forms.DateInput
                    id="cutoffDate"
                    label="Cutoff Date"
                    onChange={ props.cutoffDateChange }
                    value={ props.cutoffDate }
                    disable={ props.disable } />
            </div>
        </div>
    </React.Fragment>
);
